var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid item-header__container h-flex-container" },
    [
      _c("div", { staticClass: "grid__col--8 h-flex-item" }, [
        _c("div", { staticClass: "item-header__title" }, [
          _vm._v(_vm._s(_vm.item.title))
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "item-header__description",
          domProps: { innerHTML: _vm._s(_vm.item.description) }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid__col--4 h-flex-item" },
        [
          _vm.item.note
            ? _c(
                "div",
                { staticClass: "queue-detail item-header__note grid" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid__col--11 h-no-margin h-no-padding" },
                    [
                      _c("div", {
                        staticClass: "item-header__note-text",
                        domProps: { innerHTML: _vm._s(_vm.item.note) }
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("People", { attrs: { item: _vm.item } }),
          _vm._v(" "),
          _vm._l(_vm.agendaFiles, function(file, index) {
            return _c("FileAttachment", { key: index, attrs: { file: file } })
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__col--1 h-no-padding h-center-align" },
      [_c("i", { staticClass: "fas fa-sticky-note" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }